export default __webpack_public_path__ + "static/media/Hero-IWL-2-800x500.163ace32.jpg";